module.exports = __webpack_public_path__ + "static/options_exchange_server-6e841bd273216ac94d73431ad104736e.png";